<template>
  <div class="ml-steps" v-show="stepsToFinish > 0">
    <div class="bb-container bb-container--lista">
      <div class="ml-steps__header">
        <div
          class="bb-accordion"
          @click="toggleWizard = !toggleWizard"
          :class="toggleWizard ? 'bb-accordionn--open' : ''"
        >
          <div class="bb-accordion__title">
            <div class="bb-container bb-container--lista">
              <h2 class="ml-steps__title">
                {{ message }}
                <span class="ml-steps__subtitle">{{ stepsToFinishText }}</span>
              </h2>
            </div>
          </div>
          <span class="bb-accordion__right">
            <img
              src="../../../assets/img/ico/ico-chevron-up.svg"
              loading="lazy"
              alt=""
              width="16px"
              :class="
                toggleWizard
                  ? 'bb-accordion__chevron bb-accordion__chevron--active'
                  : 'bb-accordion__chevron '
              "
            />
          </span>
        </div>
      </div>
    </div>

    <div class="bb-container bb-container--lista bb-container--575-no-padding">
      <transition name="bbFade">
        <div class="list-section__content" v-if="toggleWizard">
          <div class="ml-steps__items">
            <div class="simple-carousel">
              <!-- Botón anterior (solo desktop) -->
              <button
                v-if="showPrevButton"
                @click="scrollPrev"
                class="carousel-nav carousel-nav--prev"
                aria-label="Anterior"
              >
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 13L1 7L7 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>

              <!-- Scroll container -->
              <div 
                class="carousel-scroll" 
                ref="scrollContainer"
                @scroll="handleScroll"
              >
                <div class="carousel-content">
                  <component
                    :is="$utils.capitalize(step) + 'Step'"
                    v-for="step in unfinishedSteps"
                    :key="'unfinished_' + step"
                    class="carousel-item"
                  ></component>
                  <component
                    :is="$utils.capitalize(step) + 'Step'"
                    v-for="step in finishedSteps"
                    :key="'finished_' + step"
                    class="carousel-item"
                  ></component>
                </div>
              </div>

              <!-- Botón siguiente (solo desktop) -->
              <button
                v-if="showNextButton"
                @click="scrollNext"
                class="carousel-nav carousel-nav--next"
                aria-label="Siguiente"
              >
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 13L7 7L1 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Features from "../../../Mixins/Features";
import ListTitleStep from "./ListTitleStep";
import PhotoStep from "./PhotoStep";
import WelcomeMessageStep from "./WelcomeMessageStep";
import ChildBirthdayStep from "./ChildBirthdayStep";
import ChildNameStep from "./ChildNameStep";
import HuchaStep from "./HuchaStep";
import InviteStep from "./InviteStep";
import UserNameStep from "./UserNameStep";

export default {
  name: "ListWizard",
  components: {
    ListTitleStep,
    PhotoStep,
    WelcomeMessageStep,
    ChildBirthdayStep,
    ChildNameStep,
    HuchaStep,
    InviteStep,
    UserNameStep,
  },
  mixins: [Features],
  data() {
    return {
      toggleWizard: true,
      isMainUser: true,
      steps: [],
      canScrollLeft: false,
      canScrollRight: false,
      isDesktop: false,
    };
  },
  computed: {
    ...mapGetters({
      list: "ownerList",
      listType: "ownerListType",
      user: "user",
      contributionsFlag: "contributionsFlag",
    }),
    message() {
      return this.stepsToFinish > 0
        ? this.$t("mylist.finishToSetupYourList")
        : this.$t("mylist.setupYourList");
    },
    finishedSteps() {
      return (this.steps || []).filter((step) => {
        return this[step + "Step"];
      });
    },
    unfinishedSteps() {
      return (this.steps || []).filter((step) => {
        return !this[step + "Step"];
      });
    },
    userNameStep() {
      return this.user?.name !== "" && this.user?.name != null;
    },
    listTitleStep() {
      return (
        this.list.title !== "" &&
        this.list.title != null &&
        this.list.title !== this.$t("mylist.defaultListName")
      );
    },
    photoStep() {
      return this.list.photo !== "" && this.list.photo != null && this.list.photo !== "default-profile-image.jpg";
    },
    welcomeMessageStep() {
      return this.list?.welcomeMessage !== "" && this.list?.welcomeMessage != null;
    },
    childBirthdayStep() {
      return !this.isBabyList || (this.list?.childBirthday !== "" && this.list?.childBirthday != null);
    },
    childNameStep() {
      return !this.isBabyList || (this.list?.childName !== "" && this.list?.childName != null);
    },
    inviteStep() {
      return (
        this.user?.partner != null ||
        this.user?.collaboratorRefused ||
        this.user?.invitationText !== null
      );
    },
    HuchaStep() {
      const isConfigured = this.user?.contributionMethods.length > 0;
      return isConfigured || this.user.contributionsRefused;
    },
    stepsToFinish() {
      // Contar los pasos que están en el array de steps
      let totalSteps = this.steps.length;
      
      // Contar cuántos están completados
      let completedSteps = 0;
      
      this.steps.forEach(step => {
        const stepCompleted = this[step + "Step"];
        if (stepCompleted) {
          completedSteps++;
        }
      });
      
      return totalSteps - completedSteps;
    },
    stepsToFinishText() {
      if (this.stepsToFinish === 0) {
        return "";
      }
      if (this.stepsToFinish === 1) {
        return "(" + this.$t("mylist.pendingStep") + ")";
      }
      return "(" + this.$t("mylist.pendingSteps", { steps: this.stepsToFinish }) + ")";
    },
    isBabyList() {
      return this.$utils.isBabyList(this.listType);
    },
    includeCollaboratorStep() {
      return this.isBabyList || this.listType === "wedding";
    },
    showPrevButton() {
      return this.isDesktop && this.canScrollLeft;
    },
    showNextButton() {
      return this.isDesktop && this.canScrollRight;
    },
  },
  methods: {
    handleScroll() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      this.canScrollLeft = container.scrollLeft > 10;
      this.canScrollRight = 
        container.scrollLeft < (container.scrollWidth - container.clientWidth - 10);
    },
    scrollNext() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      const itemWidth = container.querySelector('.carousel-item')?.offsetWidth || 0;
      const gap = 12; // 0.75rem
      container.scrollBy({ 
        left: itemWidth + gap, 
        behavior: 'smooth' 
      });
    },
    scrollPrev() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      const itemWidth = container.querySelector('.carousel-item')?.offsetWidth || 0;
      const gap = 12;
      container.scrollBy({ 
        left: -(itemWidth + gap), 
        behavior: 'smooth' 
      });
    },
    checkIsDesktop() {
      this.isDesktop = window.innerWidth >= 768;
      this.$nextTick(() => {
        this.handleScroll();
      });
    },
    async loadWizard() {
      if (this.$utils.isApp()) {
        this.$store.commit("setUserOnServerSide", this.$getUserFromCookies());
      }

      await this.$store.dispatch("getConnectedUser");

      this.steps = [
        "listTitle",
        "photo",
        "welcomeMessage",
        this.isBabyList ? "childBirthday" : null,
        this.isBabyList ? "childName" : null,
        "userName",
      ].filter(step => !!step);
      
      if (this.user?.isMainUser !== false) {
        if (this.includeCollaboratorStep) {
          this.steps.push("Invite");
        }
      }
      
      this.isMainUser = this.user?.isMainUser;
      this.checkIsDesktop();
    }
  },
  async mounted() {
    await this.loadWizard();
    window.addEventListener('resize', this.checkIsDesktop);
    
    this.$nextTick(() => {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsDesktop);
    if (this.$refs.scrollContainer) {
      this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll);
    }
  },
  watch: {
    list: {
      handler() {
        this.loadWizard();
      },
      deep: true,
    },
  }
};
</script>

<style scoped>
.simple-carousel {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.carousel-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  flex: 1;
}

.carousel-scroll::-webkit-scrollbar {
  display: none;
}

.carousel-content {
  display: flex;
  padding: 0.5rem 0;
}

.carousel-item {
  flex: 0 0 auto;
}

.carousel-nav {
  display: none;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  min-width: 36px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  z-index: 10;
  color: #666;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.carousel-nav:hover {
  background: #f9f9f9;
  border-color: #ccc;
  color: #333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}

.carousel-nav:active {
  transform: scale(0.96);
}

/* Desktop: mostrar botones y ajustar tamaño de items */
@media (min-width: 768px) {
  .simple-carousel {
    padding: 0 1rem;
  }

  .carousel-nav {
    display: flex;
  }
  
  .carousel-item {
    width: calc((100% - (0.75rem * 3)) / 4);
    min-width: 200px;
  }
  
  .carousel-scroll {
    scroll-snap-type: x mandatory;
    padding: 0 0.5rem;
  }
  
  .carousel-item {
    scroll-snap-align: start;
  }
}

/* Tablet */
@media (min-width: 600px) and (max-width: 767px) {
  .carousel-item {
    width: calc((100% - 0.75rem) / 2);
    min-width: 250px;
  }
}

/* Mobile */
@media (max-width: 599px) {
  .simple-carousel {
    padding: 0;
  }
  
  .carousel-scroll {
    scroll-snap-type: x mandatory;
  }
  
  .carousel-content {
    padding: 0.5rem 7.5%;
    gap: 0;
  }
  
  .carousel-item {
    width: 65vw;
    scroll-snap-align: center;
  }
}
</style>
